export default __webpack_public_path__ + "3180cb8241db8a25ad21c61f2e3a9030.png";